import { Component, Input } from '@angular/core';
import { PopoverController, IonicModule } from '@ionic/angular';
import { IonList, IonItem } from "@ionic/angular/standalone";

export interface Language {
  code: string;
  name: string;
  flag: string;
}

@Component({
  selector: 'app-popover',
  templateUrl: './popover.component.html',
  styleUrls: ['./popover.component.scss'],
  imports: [IonicModule],
})
export class PopoverComponent {

  @Input() languages: Language[] = [];

  constructor(private popoverCtrl: PopoverController) { }

  selectLanguage(lang: Language) {
    this.popoverCtrl.dismiss(lang); // return the selected language
  }

  closePopover() {
    this.popoverCtrl.dismiss();
  }
}
